import { render, staticRenderFns } from "./customer-form.vue?vue&type=template&id=28d43939&"
import script from "./customer-form.vue?vue&type=script&lang=ts&"
export * from "./customer-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports